import styled from "styled-components";
import { Link } from "gatsby";
import { appear } from "../../constants/animationConstants";

export const Section = styled.section`
  display: block;
  width: 100vw;
  min-height: 100vh;
  background: #7165e3;
  margin-bottom: 60px;

  @media (min-width: 768px) {
    margin-bottom: 100px;
  }
`;

export const Wrapper = styled.div`
  background: #7165e3;
  width: 100%;
`;

export const Container = styled.div`
  align-items: flex-start;
  width: 320px;
  padding: 20px 16px;

  @media (min-width: 768px) {
    width: 768px;
    padding: 20px 20px;
  }

  @media (min-width: 1440px) {
    width: 1440px;
    height: 100vh;
    padding: 22px 50px 0 150px;
  }
`;

export const Header = styled.header`
  width: 100%;
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  margin-bottom: 48px;

  @media (min-width: 1440px) {
    margin-bottom: 18vh;
  }
`;

export const LinkLogo = styled(Link)`
  margin: 0;
`;

export const Logo = styled.img`
  width: 125px;
  margin-top: 4px;

  @media (min-width: 768px) {
    width: 152px;
    margin-top: 10px;
  }

  @media (min-width: 1440px) {
    margin-top: 0;
  }
`;

export const RightHeader = styled.nav`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  margin: 0;

  @media (min-width: 768px) {
    flex-direction: row;
    justify-content: space-between;
  }

  @media (min-width: 1440px) {
    margin-right: 100px;
  }
`;

export const IconAppNameContainer = styled.div`
  display: flex;
  flex-direction: column;

  @media (min-width: 1440px) {
    flex-direction: row;
    justify-content: start;
    margin-bottom: 26px;
  }
`;

export const Icon = styled.img`
  margin: auto;
  margin-bottom: 20px;
  width: 70px;

  @media (min-width: 768px) {
    margin-bottom: 50px;
  }

  @media (min-width: 1440px) {
    margin: 0 46px 42px 0;
    animation: ${appear} 0.3s linear;
  }
`;

export const TextContainer = styled.div`
  display: flex;
  position: relative;
  height: 126px;

  @media (min-width: 768px) {
    width: 458px;
    height: 216px;
    margin: auto;
  }

  @media (min-width: 1440px) {
    height: 26vh;
    margin: 0;
  }
`;

export const Text = styled.p`
  font-weight: 900;
  font-size: 17px;
  line-height: 24px;
  color: white;
  letter-spacing: 0.04em;
  text-align: center;

  @media (min-width: 768px) {
    font-size: 24px;
    line-height: 36px;
  }

  @media (min-width: 1440px) {
    font-size: 24px;
    line-height: 36px;
    text-align: left;
  }
`;

export const SocialButtonsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 60px;

  @media (min-width: 768px) {
    width: 290px;
    margin: auto;
    margin-bottom: 100px;
  }

  @media (min-width: 1440px) {
    width: 192px;
    height: 144px;
    display: flex;
    flex-direction: column-reverse;
    margin: 0;
  }
`;

export const GoogleButton = styled.img`
  width: 136px;
  border-radius: 7px;

  @media (min-width: 1440px) {
    width: 192px;
  }
`;

export const AppleLink = styled.a`
  @media (min-width: 1440px) {
    margin: 0;
  }
`;

export const AppleButton = styled.img`
  width: 121px;
  border-radius: 7px;

  @media (min-width: 1440px) {
    width: 170px;
  }
`;

export const Video = styled.div`
  position: absolute;
  margin-top: 150px;
  margin-left: 280px;

  @media (min-width: 1440px) {
    margin-top: -480px;
    margin-left: 750px;
  }
`;

export const MainSectionImage = styled.img`
  @media (max-width: 767px) {
    width: 288px;
  }

  @media (min-width: 768px) {
    width: 600px;
    margin-left: 20px;
    margin-bottom: 64px;
  }

  @media (min-width: 1440px) {
    margin-bottom: 0;
    margin-left: 488px;
    margin-top: -550px;
  }
`;
